import React, { useEffect } from "react";
import AnimatedSection from "@/components/animation/AnimatedSection/AnimatedSection";
import ContactForm from "@/components/ContactForm";
import { CheckOutlined } from "@ant-design/icons";

// HeroSection: keep your black & white hero, unchanged
const HeroSection = () => (
  <section className="flex flex-col">
    <div className="w-full pt-8 px-6 sm:px-12 flex flex-col sm:flex-row justify-between items-start">
      <div className="flex flex-col sm:flex-row sm:items-start">
        <div className="flex flex-row items-start">
          <span className="text-[70px] sm:text-[150px] leading-none font-bold text-black font-sans tracking-tight select-none">
            TITAN <br />
            Containers
          </span>
        </div>
      </div>
    </div>
  </section>
);

const GetStartedPage = ({ history }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      {/* <AnimatedSection>
        <HeroSection />
      </AnimatedSection> */}
      <AnimatedSection>
        <ContactForm headingAs="h1" />
      </AnimatedSection>
    </div>
  );
};

export default GetStartedPage;
